import React, { Component } from "react"

import thewords from "../words"

export default class Footdetail extends Component {
    constructor(props) {
    super(props);
    this.state = {
      thewords : thewords,
    }

    this.state['theprint'] = this.state.thewords[Math.floor(Math.random() * Math.floor(this.state.thewords.length))]
    this.onHoverChangeTB = this.onHoverChangeTB.bind(this)
    this.onHoverLeave = this.onHoverLeave.bind(this)
}

componentDidMount() {
  this.interval = setInterval(() => this.setState({ theprint: this.state.thewords[Math.floor(Math.random() * Math.floor(this.state.thewords.length))] }), 10000);
}
componentWillUnmount() {
  clearInterval(this.interval);
}

  onHoverChangeTB() {
        var tb = <div className="headlinebox"><p className="headlinetext">Notes on nothing much</p></div>;
        this.props.onSelectTB(tb);
}

onHoverLeave() {
        var tb = "";
        this.props.onSelectTB(tb);
}

  render() {
  return (
      <div onMouseEnter={this.onHoverChangeTB} onMouseLeave={this.onHoverLeave} className="footertext">
        <p>{this.state.theprint}</p>
      </div>
  )
}
}

